<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          <b>Deletar Veículo</b>
        </p>
        <button type="button" class="delete" @click="cancel" />
      </header>
      <section class="modal-card-body">
        <p>
          Deseja realmente remover o veículo <b>{{ item?.placa }}</b>?
        </p>
        <p>Esta ação não poderá ser desfeita!</p>
        <br>
        <b><p>* Todos os dados vinculados a este veículo serão excluídos.</p></b>
      </section>
      <footer class="modal-card-foot">
        <b-button native-type="button" type="is-danger" outlined @click="cancel">
          Cancelar
        </b-button>
        <b-button type="is-danger" @click="confirm">
          Deletar
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import { defineComponent } from 'vue';
import VeiculoService from '@/services/VeiculoService';

export default defineComponent({
  name: 'ModalDeleteVeiculo',
  props: {
    isActive: Boolean, // Controla a visibilidade do modal
    item: Object, // Recebe o objeto do veículo a ser deletado
  },
  emits: ['cancel', 'confirm'],
  data() {
    return {
      isModalActive: this.isActive, // Sincroniza o estado do modal com a prop isActive
    };
  },
  watch: {
    isActive(newVal) {
      this.isModalActive = newVal; // Atualiza o estado do modal quando a prop muda
    },
  },
  methods: {
    confirm() {
      const id = this.item.id; // Obtém o ID do veículo

      VeiculoService.deleteVeiculo(id)
        .then(() => {
          this.$buefy.toast.open({
            message: 'Veículo Deletado!',
            position: 'is-bottom',
            type: 'is-info',
          });
          this.$emit('confirm'); // Emite o evento de confirmação
          this.isModalActive = false; // Fecha o modal
        })
        .catch((error) => {
          if (error.response) {
            this.$buefy.toast.open({
              message: `Erro ao deletar Veículo: ${error.response.data.message}`,
              position: 'is-bottom',
              type: 'is-danger',
            });
          }
          console.error(error);
        });
    },
    cancel() {
      this.$emit('cancel'); // Emite o evento de cancelamento
      this.isModalActive = false; // Fecha o modal
    },
  },
});
</script>